<template>
	<Teleport v-if="isMounted && isActive" to="#billing-popup-action">
		<PButton
			@click="onClick"
			title="GooglePlayButton"
			:path="['OnboardingPaywall', 'PaymentMethodPopup']"
			cls="btn-primary btn-block btn-compact"
		>
			<img class="googleplay" src="@/assets/billing/googleplay.svg" alt="" />
		</PButton>
	</Teleport>
</template>

<script setup>
import useLifeCycleState from '@/composition/lifeCycleState'
import PButton from '@/components/Button'

defineProps({
	isActive: {
		type: Boolean,
		default: false
	}
})

const emits = defineEmits('submit')

const onClick = () => {
	emits('submit', { provider: 'InApp' })
}
const { isMounted } = useLifeCycleState()
</script>

<style lang="scss">
.googleplay {
	display: block;
	margin-left: auto;
	margin-right: auto;
	height: 1.5rem;
}
</style>
